export default __webpack_public_path__ + "static/avatar-kayi-common-8-detail-fafda9242836d85dffc9f59ba90bba93.png";